module.exports = __webpack_public_path__ + "media/customizations/austinpoint/back-2192c10ba9e0ae4221fc4961efd096c4.jpg";